var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationUpdateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2307 0.92304C27.7894 0.92304 35.5384 8.67182 35.5384 18.2307C35.5384 27.7895 27.7894 35.5383 18.2307 35.5383C8.67193 35.5383 0.923004 27.7895 0.923004 18.2307C0.923004 8.67182 8.67193 0.92304 18.2307 0.92304Z",
    fill: "#304D63"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3685 9.39332C27.9371 9.30075 27.5127 9.57559 27.4203 10.0068L26.84 12.715C24.9923 9.56287 21.6009 7.58487 17.8839 7.58487C12.1596 7.58487 7.50262 12.2418 7.50262 17.9662C7.50262 18.4072 7.86012 18.7647 8.30119 18.7647C8.74218 18.7647 9.09975 18.4072 9.09975 17.9662C9.09975 13.1225 13.0403 9.18199 17.8839 9.18199C21.0417 9.18199 23.922 10.8687 25.4814 13.5545L22.8191 12.9839C22.3877 12.8915 21.9633 13.1662 21.871 13.5975C21.7786 14.0287 22.0533 14.4533 22.4845 14.5456L27.0546 15.525C27.1322 15.5417 27.211 15.5465 27.2888 15.5399C27.4183 15.529 27.5445 15.4865 27.6557 15.4146C27.8335 15.2995 27.9584 15.1186 28.0028 14.9115L28.9822 10.3414C29.0744 9.91028 28.7997 9.48583 28.3685 9.39332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5649 16.9195C27.1242 16.934 26.7786 17.3031 26.7931 17.7439C26.8706 20.089 26.0302 22.3237 24.4267 24.0368C22.8233 25.7497 20.6488 26.7358 18.3037 26.8132C18.206 26.8164 18.1088 26.818 18.0114 26.818C14.9516 26.8179 12.1329 25.2287 10.541 22.654L13.3166 23.3983C13.7426 23.5124 14.1805 23.2598 14.2947 22.8337C14.4089 22.4077 14.1562 21.9699 13.7302 21.8555L9.21588 20.6451C9.01132 20.5904 8.79329 20.619 8.60994 20.7248C8.42646 20.8306 8.29262 21.0051 8.23774 21.2096L7.02745 25.7241C6.91322 26.1501 7.16595 26.588 7.59193 26.7022C7.66125 26.7208 7.73075 26.7298 7.79924 26.7298C8.15175 26.7298 8.47444 26.4944 8.57007 26.1378L9.25038 23.6005C11.1429 26.5805 14.4371 28.4152 18.011 28.4151C18.1258 28.4151 18.2413 28.4133 18.3565 28.4094C21.1279 28.3178 23.6978 27.1526 25.5928 25.1282C27.4878 23.1038 28.481 20.4626 28.3894 17.6912C28.3749 17.2505 28.0056 16.9038 27.5649 16.9195Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationUpdateIcon);
export default __webpack_public_path__ + "static/media/notification_update_icon.9044d6f1da35fdf3ab3436fffa41dbd2.svg";
export { ForwardRef as ReactComponent };